import { today } from 'AppReact';

export default {
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.TitleWrapper.GoBack': ({ startDate, endDate, selectedTimeSpan }, outlet, internalStateSetter) => {
    outlet({ action: 'close', startDate, endDate, selectedTimeSpan });
    internalStateSetter({ openCalendar: false });
  },
  'MobileSideDatePicker.Wrapper.Wrapper.CloseIcon': ({ startDate, endDate, selectedTimeSpan }, outlet, internalStateSetter) => {
    outlet({ action: 'close', startDate, endDate, selectedTimeSpan })
    internalStateSetter({ openCalendar: false });
  },
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.OptionsWrapper.Buttons': async ({ startDate, endDate, selectedTimeSpan, yearListRef, monthListRef }, _, internalStateSetter) => {
    let selectedYear = endDate?.getFullYear() ?? today().getFullYear();

    await internalStateSetter({ startDate, endDate, selectedTimeSpan, openCalendar: selectedTimeSpan === 'custom', editingDate: 'startDate', selectedYear });

    yearListRef?.current?.children?.[selectedYear - 2000]?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

    if (endDate?.getFullYear() === selectedYear) {
      setTimeout(function () {
        monthListRef?.current?.children?.[endDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 800);
    } else if (startDate?.getFullYear() === selectedYear) {
      setTimeout(function () {
        monthListRef?.current?.children?.[startDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      }, 800);
    }
  },
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.YearList.Year': ({ year, monthListRef, endDate, startDate }, _, internalStateSetter) => {
    internalStateSetter({ selectedYear: year });

    if (endDate?.getFullYear() === year) {
      monthListRef?.current?.children?.[endDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else if (startDate?.getFullYear() === year) {
      monthListRef?.current?.children?.[startDate.getMonth()]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    } else {
      monthListRef?.current?.children?.[0]?.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  },
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.Button': ({ startDate, endDate, selectedTimeSpan }, outlet) => {
    outlet({ action: 'close', startDate, endDate, selectedTimeSpan })
  },
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.CustomHeader': ({ selectedDate, action, startDate, endDate }, _, internalStateSetter) => {
    if (action === 'selectStartDate') {
      internalStateSetter({ editingDate: 'startDate' })
    }
    if (action === 'selectEndDate') {
      internalStateSetter({ editingDate: 'endDate' })
    }
    if (action === 'changeStartDate') {
      internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', endDate: selectedDate > endDate ? selectedDate : endDate });
    }
    if (action === 'changeEndDate') {
      internalStateSetter({ endDate: selectedDate, editingDate: null, startDate: selectedDate < startDate ? selectedDate : startDate });
    }
  },
  'MobileSideDatePicker.Wrapper.Wrapper.ButtonsWrapper.ListWrapper.Month': ({ selectedDate, startDate, endDate, selectedTimeSpan, editingDate }, _, internalStateSetter) => {
    if (selectedTimeSpan !== 'custom') {
      if (selectedDate > endDate) {
        internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', endDate: selectedDate, selectedTimeSpan: 'custom' });
      } else {
        internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', selectedTimeSpan: 'custom' });
      }
    } else {
      if (editingDate === 'startDate') {
        if (selectedDate > endDate) {
          internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', endDate: selectedDate, selectedTimeSpan: 'custom' });
        } else {
          internalStateSetter({ startDate: selectedDate, editingDate: 'endDate', selectedTimeSpan: 'custom' });
        }
      } else {
        if (selectedDate < startDate) {
          internalStateSetter({ startDate: selectedDate, editingDate: null, endDate: selectedDate, selectedTimeSpan: 'custom' });
        } else {
          internalStateSetter({ endDate: selectedDate, editingDate: null, selectedTimeSpan: 'custom' });
        }
      }
    }
  },
}